import { render, staticRenderFns } from "./serviceRemark.vue?vue&type=template&id=51de1048&scoped=true"
import script from "./serviceRemark.vue?vue&type=script&lang=js"
export * from "./serviceRemark.vue?vue&type=script&lang=js"
import style0 from "./serviceRemark.vue?vue&type=style&index=0&id=51de1048&prod&scoped=true&lang=css"
import style1 from "./serviceRemark.vue?vue&type=style&index=1&id=51de1048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de1048",
  null
  
)

export default component.exports